<template>
  <div>
    <loader-ring v-if="getPlanLoading" class="loader-center"></loader-ring>

    <div v-else>
      <div class="row align-items-center justify-content-between mb-2">
        <div class="col">
          <h1 class="mb-2 font-regular">Target Save Plans</h1>
        </div>
        <button
          class="button button--outline text-uppercase"
          @click="openFeeModal"
          disabled
        >
          Create Plan
        </button>
      </div>
      <div class="row align-items-end my-4">
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Start Date</label>
            <input type="date" class="form-control" v-model="start_date" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Stop Date</label>
            <input type="date" class="form-control" v-model="stop_date" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <label>Search</label>
            <input type="text" class="form-control" v-model="search" />
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-12 px--5">
          <div class="form-group">
            <button @click.prevent="getPlans(1)" class="button btn">
              <!-- <span class="custom-loader" v-if="reportsLoading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;">
              Fetching Reports...
            </span>
          </span> -->
              <span>
                Submit
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="card card--no-shadow">
        <div class="card-header">
          <slot name="header">
            <h3 class="card-title">Target Save</h3>
          </slot>
        </div>
        <div class="card-content">
          <div class="card-body">
            <CDataTable
              :items="plans"
              :fields="fields"
              :items-per-page="small"
              sorter
              tableFilter
            >
              <template #customer_name="{ item }">
                <td>
                  {{ item.customer.name }}
                </td>
              </template>
              <template #email="{ item }">
                <td>
                  {{ item.customer.email }}
                </td>
              </template>
              <template #created_at="{item}">
                <td class="table--action-mobile">
                  {{ item.created_at | date }}
                </td>
              </template>
              <template #actions="{item}">
                <td class="table--action-mobile">
                  <router-link
                    :event="
                      permissions.includes('view-single-plan') ? 'click' : ''
                    "
                    :class="
                      permissions.includes('view-single-plan')
                        ? ''
                        : 'disabled cursor-not-allowed'
                    "
                    class="button"
                    :to="{
                      name: 'TargetPlanComponent',
                      params: { slug: item.reference }
                    }"
                  >
                    View Plan
                  </router-link>
                </td>
              </template>
            </CDataTable>
            <CPagination
              :activePage.sync="next_page"
              :pages="total"
              :onActivePageChange="onPageChange()"
            ></CPagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import CPagination from "@/components/CPagination";

const fields = [
  "customer_name",
  "title",
  "email",
  "reference",
  "frequency",
  "frequency_amount",
  "created_at",
  "actions"
];
export default {
  name: "AutoSave",
  components: { CDataTable, CPagination },
  data() {
    return {
      small: 20,
      fields,
      plans: [],
      next_page: 2,
      total: 1,
      // small: 10,
      current: 1,
      start_date: "",
      stop_date: "",
      search: "",
      getPlanLoading: false
    };
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.userObj.admin.permissions;
      return permissions;
    }
  },
  methods: {
    async getPlans(page) {
      try {
        this.getPlanLoading = true;
        const response = await ApiService.get(
          `backend/savings/target-save-plans?page=${page}&start_date=${this.start_date}&stop_date=${this.stop_date}&search=${this.search}`
        );

        this.plans = response.data.data.data;
        this.current = response.data.data.current_page;
        this.total = response.data.data.last_page;
        this.getPlanLoading = false;
      } catch (error) {
        console.log(error.response);
        this.getPlanLoading = false;
      }
    },
    onPageChange() {
      console.log(this.next_page);
      if (this.current != this.next_page) {
        this.getPlans(this.next_page);
      }
    }
  },
  mounted() {
    this.getPlans(1);
  }
};
</script>

<style scoped></style>
